module.exports = __webpack_public_path__ + "05_glasses_brown.f3b884e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/05_glasses_brown.png
// module id = Fudf
// module chunks = 0